import React from 'react';
export function DetailPageShimmer() {
  return <div className="space-y-6 animate-pulse" role="status" aria-busy="true" aria-live="polite" data-id="element-13797">
      <span className="sr-only" data-id="element-13798">Loading details…</span>
      {/* Back button and actions */}
      <div className="flex items-center justify-between" data-id="element-13799">
        <div className="h-5 w-32 bg-gray-200 rounded" data-id="element-13800" />
        <div className="h-10 w-28 bg-gray-200 rounded-md" data-id="element-13801" />
      </div>
      {/* Main info card */}
      <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-13802">
        <div className="flex items-start gap-4 mb-6" data-id="element-13803">
          <div className="w-16 h-16 bg-gray-200 rounded-full" data-id="element-13804" />
          <div className="flex-1" data-id="element-13805">
            <div className="h-8 w-64 bg-gray-200 rounded mb-3" data-id="element-13806" />
            <div className="space-y-2" data-id="element-13807">
              <div className="h-4 w-48 bg-gray-200 rounded" data-id="element-13808" />
              <div className="h-4 w-40 bg-gray-200 rounded" data-id="element-13809" />
              <div className="h-4 w-56 bg-gray-200 rounded" data-id="element-13810" />
            </div>
          </div>
          <div className="h-6 w-20 bg-gray-200 rounded-full" data-id="element-13811" />
        </div>
        {/* Stats */}
        <div className="pt-6 border-t border-gray-200 grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-13812">
          {[1, 2, 3].map(i => <div key={i} data-id="element-13813">
              <div className="h-3 w-24 bg-gray-200 rounded mb-2" data-id="element-13814" />
              <div className="h-8 w-32 bg-gray-200 rounded" data-id="element-13815" />
            </div>)}
        </div>
      </div>
      {/* Tabs */}
      <div className="bg-white rounded-lg border border-gray-200" data-id="element-13816">
        <div className="border-b border-gray-200 flex gap-8 px-6" data-id="element-13817">
          {[1, 2, 3].map(i => <div key={i} className="py-4" data-id="element-13818">
              <div className="h-4 w-24 bg-gray-200 rounded" data-id="element-13819" />
            </div>)}
        </div>
        {/* Tab content */}
        <div className="p-6 space-y-4" data-id="element-13820">
          {[1, 2, 3, 4, 5].map(i => <div key={i} className="border border-gray-200 rounded-lg p-4" data-id="element-13821">
              <div className="flex justify-between items-center" data-id="element-13822">
                <div className="flex-1 space-y-2" data-id="element-13823">
                  <div className="h-4 w-48 bg-gray-200 rounded" data-id="element-13824" />
                  <div className="h-3 w-32 bg-gray-200 rounded" data-id="element-13825" />
                </div>
                <div className="h-4 w-24 bg-gray-200 rounded" data-id="element-13826" />
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}